import { render, staticRenderFns } from "./TaxDetails.vue?vue&type=template&id=75be1c99&scoped=true"
import script from "./TaxDetails.vue?vue&type=script&lang=ts"
export * from "./TaxDetails.vue?vue&type=script&lang=ts"
import style0 from "./TaxDetails.vue?vue&type=style&index=0&id=75be1c99&lang=scss"
import style1 from "./TaxDetails.vue?vue&type=style&index=1&id=75be1c99&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be1c99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75be1c99')) {
      api.createRecord('75be1c99', component.options)
    } else {
      api.reload('75be1c99', component.options)
    }
    module.hot.accept("./TaxDetails.vue?vue&type=template&id=75be1c99&scoped=true", function () {
      api.rerender('75be1c99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/tax/components/TaxDetails.vue"
export default component.exports